/*
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBO
 * @Date: 2021-10-26 16:23:08
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-11-08 16:58:25
 */
import CellTypes from '@/components/tableCells/index';
let ColumnTypes = {};
Object.keys(CellTypes).forEach(item => ColumnTypes[item] = `${item}`);
export default ColumnTypes;
